import { render, staticRenderFns } from "./BtnRefresh.vue?vue&type=template&id=a4f88a5e"
import script from "./BtnRefresh.vue?vue&type=script&lang=js"
export * from "./BtnRefresh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports